var React = require('react');

function DisconnectInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.71409 1.71429H12.2855V0H-0.000192642V20H12.2855V18.2857H1.71409V1.71429Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M20.2856 10.281L12.8547 14.5713V11.9542H6.33815V8.52558H12.8547V5.99072L20.2856 10.281Z","fill":"currentColor","key":1})]);
}

DisconnectInline.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = DisconnectInline;

DisconnectInline.default = DisconnectInline;
